<ng-container *ngIf="form" [formGroup]="form">
  <div
    *ngIf="
      (completeOrderService.directDebitFormState$ | async) !==
      DirectDebitFormState.RETRIES_EXCEEDED
    "
    class="direct-debit"
    [class.direct-debit--open]="directDebitMode === Mode.EDIT"
  >
    <h4 class="inline-flex">
      {{ ddCtrl(DirectDebitControls.MonthlyPayment)?.value | currency : 'GBP' }}
    </h4>
    <p class="inline-flex ml-1">a month</p>
    <small class="d-block">Policy continues for as long as you like</small>

    <div class="flex align--center direct-debit__header">
      <h4>Direct Debit</h4>
      <img
        src="./assets/images/payment-direct-debit.png"
        alt="direct debit logo"
      />
    </div>

    <div [formGroupName]="FormStep.DirectDebit" class="direct-debit__form">
      <ng-container *ngIf="directDebitAutofillAvailable">
        <p class="mb-2">
          We have your Direct Debit details saved from a previous plan. Please
          check and confirm that these details are still valid, or you can add
          new payment details.
        </p>
        <p class="mb-4">
          These changes will only be applied to your new policy, not any of your
          ongoing plans.
        </p>
        <div
          class="error--block"
          *ngIf="
            (completeOrderService.directDebitFormState$ | async) ===
            DirectDebitFormState.INVALID
          "
        >
          Payment details not valid. Please try again
        </div>
      </ng-container>
      <div
        class="direct-debit__inner"
        [class.no-background]="!directDebitAutofillAvailable"
      >
        <div
          class="error--block"
          *ngIf="
            (completeOrderService.directDebitFormState$ | async) ===
              DirectDebitFormState.INVALID && !directDebitAutofillAvailable
          "
        >
          Payment details not valid. Please try again
        </div>

        <div
          class="form-group form-group__input accountHolder"
          [ngClass]="{
            'is-invalid': isInvalid(DirectDebitControls.AccountHolderName),
            'is-valid': isValid(DirectDebitControls.AccountHolderName)
          }"
        >
          <label for="accHolderName">
            <strong>Name of account holder</strong>
          </label>

          <p
            *ngIf="directDebitMode === Mode.READONLY"
            [dgxQmSanitise]="'block'"
          >
            {{ ddCtrl(DirectDebitControls.AccountHolderName).value }}
          </p>

          <ng-container *ngIf="directDebitMode === Mode.EDIT">
            <div class="input-wrapper">
              <input
                class="form-control"
                type="text"
                #accountHolder
                placeholder="Name of account holder"
                (focus)="onFocusDirectDebitFields()"
                [dgxQmSanitise]="'block'"
                [formControlName]="DirectDebitControls.AccountHolderName"
              />

              <div
                class="form-group__error"
                *ngIf="isInvalid(DirectDebitControls.AccountHolderName)"
                [@slideInOut]
              >
                <span *ngIf="isInvalid(DirectDebitControls.AccountHolderName)">
                  {{ DirectDebitErrors.AccountHolderNameRequired }}
                </span>
              </div>
              <i class="icon icon-tick-circle icon--xxs"></i>
              <i class="icon icon-error-circle icon--xxs"></i>
            </div>
          </ng-container>
        </div>

        <div
          class="form-group form-group__input"
          [ngClass]="{
            'is-invalid': isInvalid(DirectDebitControls.AccountNumber),
            'is-valid': isValid(DirectDebitControls.AccountNumber)
          }"
        >
          <label for="accNumber">
            <strong>Account number</strong>
          </label>
          <p *ngIf="directDebitMode === Mode.READONLY">
            {{ ddCtrl(DirectDebitControls.AccountNumber).value }}
          </p>

          <ng-container *ngIf="directDebitMode === Mode.EDIT">
            <div class="input-wrapper">
              <input
                class="form-control"
                type="text"
                placeholder="Account number"
                (focus)="onFocusDirectDebitFields()"
                [dgxQmSanitise]="'block'"
                [formControlName]="DirectDebitControls.AccountNumber"
              />

              <div
                class="form-group__error"
                *ngIf="isInvalid(DirectDebitControls.AccountNumber)"
                [@slideInOut]
              >
                <span
                  *ngIf="
                    ddCtrl(DirectDebitControls.AccountNumber)?.errors?.required
                  "
                >
                  {{ DirectDebitErrors.AccountNumberRequired }}
                </span>
                <span
                  *ngIf="
                    ddCtrl(DirectDebitControls.AccountNumber)?.errors?.pattern
                  "
                >
                  {{ DirectDebitErrors.AccountNumberPattern }}
                </span>
              </div>
              <i class="icon icon-tick-circle icon--xxs"></i>
              <i class="icon icon-error-circle icon--xxs"></i>
            </div>
          </ng-container>
        </div>

        <!-- Sortcode -->
        <div [formGroupName]="DirectDebitControls.SortCode">
          <div
            class="form-group form-group__input form-group__sortcode"
            [ngClass]="{
              'is-invalid':
                isInvalid(DirectDebitControls.SortCode) &&
                (isSortInvalid(DirectDebitControls.Sort1) ||
                  isSortInvalid(DirectDebitControls.Sort2) ||
                  isSortInvalid(DirectDebitControls.Sort3)),
              'is-valid': isValid(DirectDebitControls.SortCode)
            }"
          >
            <label>
              <strong>Sort code</strong>
            </label>
            <p *ngIf="directDebitMode === Mode.READONLY">
              {{ sortCtrl(DirectDebitControls.Sort1).value }}-{{
                sortCtrl(DirectDebitControls.Sort2).value
              }}-{{ sortCtrl(DirectDebitControls.Sort3).value }}
            </p>
            <ng-container *ngIf="directDebitMode === Mode.EDIT">
              <div class="sortcode-wrap">
                <input
                  [dgxQmSanitise]="'block'"
                  class="form-control"
                  maxlength="2"
                  name="sort1"
                  autocomplete="off"
                  type="text"
                  (focus)="onFocusDirectDebitFields()"
                  [formControlName]="DirectDebitControls.Sort1"
                />
                <input
                  class="form-control"
                  maxlength="2"
                  name="sort2"
                  [dgxQmSanitise]="'block'"
                  autocomplete="off"
                  type="text"
                  (focus)="onFocusDirectDebitFields()"
                  [formControlName]="DirectDebitControls.Sort2"
                />
                <input
                  class="form-control"
                  maxlength="2"
                  [dgxQmSanitise]="'block'"
                  name="sort3"
                  autocomplete="off"
                  type="text"
                  (focus)="onFocusDirectDebitFields()"
                  [formControlName]="DirectDebitControls.Sort3"
                />
                <i class="icon icon-tick-circle icon--xxs"></i>
                <i class="icon icon-error-circle icon--xxs"></i>
              </div>
              <div
                class="form-group__error"
                *ngIf="
                  isInvalid(DirectDebitControls.SortCode) &&
                  (isSortInvalid(DirectDebitControls.Sort1) ||
                    isSortInvalid(DirectDebitControls.Sort2) ||
                    isSortInvalid(DirectDebitControls.Sort3))
                "
                [@slideInOut]
              >
                {{ DirectDebitErrors.SortCodeRequired }}
              </div>
            </ng-container>
          </div>
        </div>
        <!-- Select -->
        <div
          class="form-group form-group__select mb-0"
          [ngClass]="{
            'is-invalid': isInvalid(DirectDebitControls.PreferredPaymentDay),
            'is-valid': isValid(DirectDebitControls.PreferredPaymentDay)
          }"
        >
          <div class="select">
            <label for="payDay">
              <strong> Preferred monthly payment day </strong>
            </label>

            <p *ngIf="directDebitMode === Mode.READONLY">
              Day
              {{ ddCtrl(DirectDebitControls.PreferredPaymentDay).value }}
              of every month
            </p>

            <div class="wrapper" *ngIf="directDebitMode === Mode.EDIT">
              <select
                class="form-control"
                name="payDay"
                [formControlName]="DirectDebitControls.PreferredPaymentDay"
              >
                <ng-container *ngFor="let day of days">
                  <option [value]="day">
                    {{ day }}
                  </option>
                </ng-container>
              </select>
              <i class="icon icon-arrow-down"></i
              ><i class="icon icon-tick-circle"></i
              ><i class="icon icon-error-circle"></i>
            </div>
          </div>

          <div
            class="form-group__error"
            *ngIf="isInvalid(DirectDebitControls.PreferredPaymentDay)"
            [@slideInOut]
          >
            <span>
              {{ DirectDebitErrors.PreferredPaymentDayRequired }}
            </span>
          </div>

          <small class="d-block typeog-caption-regular mt-2">
            If your chosen payment date is within the next 14 days, your first
            and second payments will be taken at the same time next month.
          </small>
        </div>

        <div
          class="edit__cta"
          *ngIf="directDebitAutofillAvailable && directDebitMode === Mode.EDIT"
        >
          <dgx-components-button-group [align]="'left'">
            <dgx-components-button
              class="edit-dd"
              [variant]="'secondary'"
              (clicked)="cancelEdit()"
              >Cancel</dgx-components-button
            >
            <dgx-components-button
              class="edit-dd"
              [variant]="'primary'"
              (clicked)="saveEdit()"
            >
              Save
            </dgx-components-button>
          </dgx-components-button-group>
        </div>

        <dgx-components-button
          class="amend__cta mt-3"
          [variant]="'secondary'"
          *ngIf="directDebitMode === Mode.READONLY"
          (clicked)="editDirectDebit()"
          >Change payment details</dgx-components-button
        >
      </div>

      <div class="direct-debit__terms">
        <small class="mt-2 d-block typog-body">
          Paying for your policy by Direct Debit means that you do not need to
          do anything to ensure that you stay protected. Cover continues for as
          long as you like, with monthly Direct Debit collections.
        </small>

        <p class="mt-2 mb-4">
          <a [href]="ddGuaranteeLink" target="_blank" class="link link--primary"
            >The Direct Debit Guarantee</a
          >
        </p>

        <hr />

        <section class="terms-and-conditions">
          <h3>Terms and Conditions</h3>

          <p>
            This insurance policy is designed to meet the demands and needs of
            those who wish to insure their electronic appliances and/or
            household goods against breakdown and accidental damage. Full
            details on how to submit a complaint can be found in the
            <a
              [href]="'/assets/pdf/' + pdfFolderPath?.termsAndConditions"
              target="_blank"
              >Appliance Care Terms and Conditions</a
            >.
          </p>
          <p>
            You must read the
            <a [href]="'/assets/pdf/' + pdfFolderPath?.ipid" target="_blank"
              >Appliance Care Insurance Product Information Document</a
            >
            before purchase. You must be at least 18 years old to buy this
            policy. Your data will be handled in accordance with our
            <a
              target="_blank"
              href="https://www.domesticandgeneral.com/privacy-cookies-policy"
              >Privacy Policy</a
            >.
          </p>

          <label for="confirm-read">
            <dgx-components-icon
              size="xl"
              [name]="confirmTermsAndConditionsRead ? 'square-check' : 'square'"
              [class.error-tick]="showReadTermsAndConditionError"
            >
            </dgx-components-icon>

            <input
              [(ngModel)]="confirmTermsAndConditionsRead"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="showReadTermsAndConditionError = false"
              id="confirm-read"
              name="confirm-read"
              type="checkbox"
            />
            By ticking this box, you confirm that you have read the documents
            and that this product meets your demands and needs.
          </label>
          <label for="paper-copy">
            <dgx-components-icon
              size="xl"
              [name]="
                ddCtrl(DirectDebitControls.PostPolicy).value
                  ? 'square-check'
                  : 'square'
              "
            >
            </dgx-components-icon>

            <input
              [checked]="ddCtrl(DirectDebitControls.PostPolicy).value"
              [formControlName]="DirectDebitControls.PostPolicy"
              id="paper-copy"
              name="paper-copy"
              type="checkbox"
            />

            Yes, post a copy of my documents. (We’ll email all of your policy
            documents to you, check this only if you also want a hardcopy.)
          </label>
        </section>

        <hr />

        <p class="mb-2 typog-body-bold confirm-details">
          By submitting my payment details I confirm I am the account
          holder/card holder and that no authority other than my own is
          required.
        </p>
      </div>

      <div class="spacer"></div>

      <div
        class="error--block"
        *ngIf="completeOrderService.directDebitValidationError$ | async"
      >
        Sorry, the system encountered a problem and could not validate your
        direct debit details.<br />You can continue with your order and we will
        contact you if there is a problem with your direct debit
      </div>

      <ng-container
        *ngIf="
          directDebitAutofillAvailable;
          else directDebitAutofillUnavailable
        "
      >
        <div class="form__field">
          <!-- cta -->

          <section *ngIf="showReadTermsAndConditionError" class="confirm-error">
            <dgx-components-icon name="circle-exclamation">
            </dgx-components-icon>
            <p>Please accept the Terms and Conditions before continuing</p>
          </section>

          <dgx-components-button
            [variant]="'primary'"
            (clicked)="onDirectDebitContinue()"
            class="mt-8 mb-8"
            *ngIf="directDebitMode === Mode.READONLY"
            [disabled]="
              completeOrderService.directDebitValidationLoading$ | async
            "
            >{{
              (completeOrderService.replacementCost$ | async)
                ? 'Setup and continue'
                : 'Confirm order and cover'
            }}
          </dgx-components-button>
        </div>
      </ng-container>

      <ng-template #directDebitAutofillUnavailable>
        <ng-container
          *ngIf="
            completeOrderService.replacementCost$ | async;
            else noUpfrontCost
          "
        >
          <dgx-components-button
            [variant]="'primary'"
            (clicked)="onDirectDebitContinue()"
            class="mt-6 mb-8"
            *ngIf="
              (completeOrderService.directDebitFormState$ | async) !==
                DirectDebitFormState.VALID &&
              (completeOrderService.directDebitFormState$ | async) !==
                DirectDebitFormState.ERROR
            "
            [disabled]="
              completeOrderService.directDebitValidationLoading$ | async
            "
            >Setup and continue
          </dgx-components-button>

          <dgx-components-button
            [variant]="'primary'"
            (clicked)="handleDirectDebitApiFail()"
            class="mt-6 mb-8"
            *ngIf="
              (completeOrderService.directDebitFormState$ | async) ===
              DirectDebitFormState.ERROR
            "
            [disabled]="
              completeOrderService.directDebitValidationLoading$ | async
            "
            >Setup and continue
          </dgx-components-button>

          <div
            class="form__field"
            *ngIf="
              (completeOrderService.directDebitFormState$ | async) ===
              DirectDebitFormState.VALID
            "
          >
            <dgx-components-button
              [variant]="'primary'"
              (clicked)="onContinueClick(FormStep.DirectDebit)"
              >Continue</dgx-components-button
            >
          </div>
        </ng-container>

        <ng-template #noUpfrontCost>
          <dgx-components-button
            *ngIf="
              (completeOrderService.directDebitFormState$ | async) !==
              DirectDebitFormState.VALID
            "
            [variant]="'primary'"
            (clicked)="onDirectDebitContinue()"
            [disabled]="
              completeOrderService.directDebitValidationLoading$ | async
            "
            >Confirm order and cover</dgx-components-button
          >
        </ng-template>
      </ng-template>
    </div>
  </div>
  <ng-container
    *ngIf="
      (completeOrderService.directDebitFormState$ | async) ===
      DirectDebitFormState.RETRIES_EXCEEDED
    "
  >
    <div [@slide]>
      <div class="error--block">
        You have entered your Direct Debit details incorrectly too many times.
      </div>

      <p>
        You can continue with your order below and we'll be in contact about
        setting up your new policy later, or try and
        <a class="link" (click)="resetDirectDebitCardDetails()"
          >enter your direct debit details again.</a
        >
      </p>

      <dgx-components-button
        *ngIf="completeOrderService.replacementCost$ | async"
        [variant]="'primary'"
        (clicked)="onErrorRemoveUpsellContinueClick(FormStep.DirectDebit)"
        >Continue with order</dgx-components-button
      >

      <dgx-components-button
        *ngIf="(completeOrderService.replacementCost$ | async) === 0"
        [variant]="'primary'"
        (clicked)="onErrorCreateOrderClick()"
        >Confirm order
      </dgx-components-button>
    </div>
  </ng-container>
</ng-container>
